import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderHandling } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type SetOrderHandlingProps = {
  formData: IOrderHandling;
} & RequestsProps;

export type UseSetOrderHandlingReturn = {
  create: (props: SetOrderHandlingProps) => Promise<void>;
} & UseLoadingReturn;

const useSetOrderHandling = (): UseSetOrderHandlingReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderHandling>({
    operation: (formData) => orderStatusService.handling(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useSetOrderHandling;
